<!--
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-26 10:16:49
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-27 18:28:40
-->
<template>
  <div>
      <!-- <PageHeaderLayout :isBack="true"> -->
        <div class="main-page-content">
          <span>正在开发中，此功能暂未开放。</span>
        </div>
      <!-- </PageHeaderLayout> -->
  </div >
</template>

<script>
// import PageHeaderLayout from "@/layouts/PageHeaderLayout";
export default {
  components: {
    // PageHeaderLayout,
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="stylus" scoped>
.main-page-content
  display flex
  text-align center
  justify-content center
  align-items center
  min-height 600px
  span
    font-size 36px
</style>
